import React from "react";
import { Typography } from "@material-ui/core";
import { Li, ListItem, StyledTable } from "./Components";

import fal_fal_haz_lev from "../img/sswpIcons/FallsFallingObjects/fal_fal_haz_lev.png";
import fal_fal_bar from "../img/sswpIcons/FallsFallingObjects/fal_fal_bar_fen_hoa.png";
import fal_fal_sec_sto from "../img/sswpIcons/FallsFallingObjects/fal_fal_sec_sto.png";
import fal_fal_loa_bay from "../img/sswpIcons/FallsFallingObjects/fal_fal_loa_bay.png";
import fal_fal_goo_per_hoi from "../img/sswpIcons/FallsFallingObjects/fal_fal_goo_per_hoi.png";
import fal_fal_pal_bal_sec from "../img/sswpIcons/FallsFallingObjects/fal_fal_pal_bal_sec.png";
import fal_fal_veh_pla_con from "../img/sswpIcons/FallsFallingObjects/fal_fal_veh_pla_con.png";
import fal_fal_blo_cor from "../img/sswpIcons/FallsFallingObjects/fal_fal_blo_cor.png";
import fal_fal_lif_poi_eye from "../img/sswpIcons/FallsFallingObjects/fal_fal_lif_poi_eye.png";
import fal_fal_net_bea_bag from "../img/sswpIcons/FallsFallingObjects/fal_fal_net_bea_bag.png";
import fal_fal_blo_gra from "../img/sswpIcons/FallsFallingObjects/fal_fal_blo_gra.png";
import fal_fal_cab_guar from "../img/sswpIcons/FallsFallingObjects/fal_fal_cab_gua.png";
import fal_fal_mas_cli from "../img/sswpIcons/FallsFallingObjects/fal_fal_mas_cli.png";
import fal_fal_sti from "../img/sswpIcons/FallsFallingObjects/fal_fal_sti.png";
import fal_fal_sit_spe_met_sta from "../img/sswpIcons/FallsFallingObjects/fal_fal_sit_spe_met.png";
import fal_fal_edg_pro from "../img/sswpIcons/FallsFallingObjects/fal_fal_edg_pro.png";
import fal_fal_exc_zon from "../img/sswpIcons/FallsFallingObjects/fal_fal_exc_zon.png";
import fal_fal_exa_ins from "../img/sswpIcons/FallsFallingObjects/fal_fal_exa_ins.png";
import fal_fal_she_fan from "../img/sswpIcons/FallsFallingObjects/fal_fal_she_fan.png";
import fal_fal_har from "../img/sswpIcons/FallsFallingObjects/fal_fal_har.png";
import fal_fal_lad from "../img/sswpIcons/FallsFallingObjects/fal_fal_lad.png";
import fal_fal_roo_lad from "../img/sswpIcons/FallsFallingObjects/fal_fal_roo_lad.png";
import fal_fal_a_lad from "../img/sswpIcons/FallsFallingObjects/fal_fal_a_lad.png";
import fal_fal_sta_pro from "../img/sswpIcons/FallsFallingObjects/fal_fal_sta_pro.png";
import fal_fal_mew from "../img/sswpIcons/FallsFallingObjects/fal_fal_mewp.png";
import fal_fal_ope_hol from "../img/sswpIcons/FallsFallingObjects/fal_fal_ope_hol.png";
import fal_fal_pro from "../img/sswpIcons/FallsFallingObjects/fal_fal_pro.png";
import fal_fal_ris_ass from "../img/sswpIcons/FallsFallingObjects/fal_fal_ris_ass_and_saf_pla.png";
import fal_fal_saf_lad from "../img/sswpIcons/FallsFallingObjects/fal_fal_saf_lad.png";
import fal_fal_sca from "../img/sswpIcons/FallsFallingObjects/fal_fal_sca.png";
import fal_fal_mob_sca from "../img/sswpIcons/FallsFallingObjects/fal_fal_mob_sca.png";
import fal_fal_sop from "../img/sswpIcons/FallsFallingObjects/fal_fal_sop.png";
import fal_fal_sur from "../img/sswpIcons/FallsFallingObjects/fal_fal_sur.png";
import fal_fal_tie_lad from "../img/sswpIcons/FallsFallingObjects/fal_fal_tie_lad.png";
import fal_fal_tre_pla from "../img/sswpIcons/FallsFallingObjects/fal_fal_tre_pla.png";
import fal_fal_war_sig from "../img/sswpIcons/FallsFallingObjects/fal_fal_wor_war.png";
import fal_fal_wor_pla from "../img/sswpIcons/FallsFallingObjects/fal_fal_wor_pla.png";
import fal_fal_chu from "../img/sswpIcons/FallsFallingObjects/fal_fal_chu.png";
import fal_fal_cra_boa from "../img/sswpIcons/FallsFallingObjects/fal_fal_cra_boa.png";
import fal_fal_oh_wor from "../img/sswpIcons/FallsFallingObjects/fal_fal_oh_wor.png";

const json = {
    icon: fal_fal_haz_lev,
    name: "Falls And Falling Objects",
    text: (
        <ul>
            <ListItem text="If needed “Where there is a hazard present from either operatives falling, or falling objects injuring operatives”" />
        </ul>
    ),
    icons: {
        fal_fal_ris_ass_and_saf_pla: {
            name: "Risk Assess & Plan Safe Method",
            icon: fal_fal_ris_ass,
            text: (
                <ul>
                    <ListItem text="Every work activity needs to be risk assessed prior to commencing. Identify potential hazards. Assess the likelihood of something happening, and the severity if something did go wrong. Select appropriate controls that will be put in place before the activity begins." />
                </ul>
            )
        },
        fal_fal_sop: {
            name: "SOP",
            icon: fal_fal_sop,
            text: (
                <ul>
                    <ListItem text="The Safe System of Work is a set of procedures that must be followed" />
                    <ListItem text="High risk activities will require a documented SOP with step by step procedures. " />
                    <ListItem text="They should detail the scope of conditions under which they can be used, including work locations, scale of hazards/risks present, works durations etc. The SOP can only be used when all conditions have been met. If such conditions have not been met, then a Site Specific Method Statement will be required." />
                </ul>
            )
        },
        fal_fal_wor_war: {
            name: "Warning Signs",
            icon: fal_fal_war_sig,
            text: (
                <ul>
                    <ListItem text="Signs will alert workers/public that they are approaching high-risk areas (e.g. exclusion zones, fall risks etc)." />
                    <ListItem text="Signs should use standardised graphical pictograms to communicate the hazard and may have supplementary information in written format." />
                    <Li>
                        <Typography variant="title">
                            Graphical symbols should NOT be combined to convey
                            more than one safety message. E.g. separate symbols
                            for hard hat and eye protection.
                        </Typography>
                        <StyledTable>
                            <tbody>
                                <tr>
                                    <th>Sign Type</th>
                                    <th>Meaning</th>
                                    <th>Shape & Colour</th>
                                </tr>
                                <tr>
                                    <td>Prohibition</td>
                                    <td>Not permitted</td>
                                    <td>
                                        <ul>
                                            <li>Shape: Round </li>
                                            <li>Backing colour: White</li>
                                            <li>
                                                Symbol colour: Black with red
                                                diagonal
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Fire fighting</td>
                                    <td>Location and identification of type</td>
                                    <td>
                                        <ul>
                                            <li>Shape: Rectangle </li>
                                            <li>Backing colour: Red</li>
                                            <li>Symbol colour: White</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Warning</td>
                                    <td>Take precaution</td>
                                    <td>
                                        <ul>
                                            <li>Shape: Triangle</li>
                                            <li> Backing colour: Yellow</li>
                                            <li> Symbol colour: Black</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Emergency escape</td>
                                    <td>Escape route</td>
                                    <td>
                                        <ul>
                                            <li>Shape: Rectangle </li>
                                            <li>Backing colour: Green</li>
                                            <li>Symbol colour: White</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Supplementary Information</td>
                                    <td>Additional Info</td>
                                    <td>
                                        <ul>
                                            <li>Shape: Rectangle</li>
                                            <li> Backing colour: White</li>
                                            <li> Symbol colour: Black</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Obstacles</td>
                                    <td>Collision risk</td>
                                    <td>
                                        <ul>
                                            <li>Chevron</li>
                                            <li> Black/Yellow </li>
                                            <li>Red/White</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Traffic Route</td>
                                    <td>Vehicles to keep between</td>
                                    <td>Continuous white or yellow lines.</td>
                                </tr>
                            </tbody>
                        </StyledTable>
                    </Li>
                </ul>
            )
        },
        fal_fal_exa_ins: {
            name: "Examination/ Inspection",
            icon: fal_fal_exa_ins,
            text: (
                <ul>
                    <ListItem text="A person with the necessary mix of training, knowledge and experience must regularly examine the effectiveness of the controls" />
                    <ListItem text="Any defects or inadequacy must be noted and remedial action taken immediately." />
                    <Li>
                        <Typography variant="title">
                            For excavations, inspections must occur
                        </Typography>
                        <ol>
                            <ListItem text="At least once every day during which persons are working" />
                            <ListItem text="If > 2m deep, at the start of each shift" />
                            <ListItem text="After any event likely to have affected the strength or stability of the excavation or shoring" />
                            <ListItem text="After any accidental fall or rock, earth or other material" />
                            <ListItem text="At least once every 7 days where persons are not at work there" />
                            <ListItem text="The inspection should complete an AF3 form." />
                        </ol>
                    </Li>
                </ul>
            )
        },
        fal_fal_sur: {
            name: "Surveying",
            icon: fal_fal_sur,
            text: (
                <ul>
                    <ListItem text="Before commencing, the area should be visually assessed for hazards" />
                    <ListItem text="Workers can only enter the area after appropriate controls have been put in place." />
                </ul>
            )
        },
        fal_fal_pro: {
            name: "Propping",
            icon: fal_fal_pro,
            text: (
                <ul>
                    <ListItem text="Propping may be needed even in shallow trenches (<1.25m), particularly if ground conditions are particularly poor or the nature of the work requires workers to lie or crouch in the trench." />
                    <ListItem text="Propping with soldier sets is a simple form of trench support set which can be formed with steel or timber. This system is mostly used in rock, stiff clays and in other soil types with similar self-supporting properties. " />
                    <ListItem text="Unlike shoring, soldier sets retain the earth where there may be a fault in the embankment. Soldier sets only provide ground support at regular intervals and do not provide positive ground support to the whole excavated face. Open soldier sets are only suitable for use in stable soil types." />
                    <Li>
                        <Typography variant="title">
                            The following guidelines should be followed
                        </Typography>
                        <ol>
                            <ListItem text="Keep spoil at least 600mm from edge" />
                            <ListItem text="Soldiers (vertical side element) should protrude at least 500mm above top of trench" />
                            <ListItem text="Top Tom (cross-support) should be no lower than 300mm from trench top" />
                            <ListItem text="Maximum spacing between Toms no more than 750mm" />
                            <ListItem text="All jointing should be secured with nails/screws" />
                            <ListItem text="Maximum spacing between Soldiers 1.5m" />
                            <ListItem text="Minimum size of Soldier 150x38mm" />
                            <ListItem text="Minimum size of Tom 150x38mm" />
                            <ListItem text="Tom needs to be long enough to force Soldier firmly against trench side" />
                            <ListItem text="Space between bottom Tom and trench floor should allow for pipe, generally not more than 1m." />
                        </ol>
                    </Li>
                    <ListItem text="Propping can be adaptable, particularly when working around existing services and can be quick to install especially in shallow excavations." />
                    <ListItem text="It requires considerable experience and skill to install, with each arrangement requiring bespoke design." />
                </ul>
            )
        },
        fal_fal_lad: {
            name: "Ladder",
            icon: fal_fal_lad,
            text: (
                <ul>
                    <ListItem text="Ladders should NOT be used to carry out works that will be in one position for > 30 minutes. Other methods should be selected." />
                    <ListItem text="All ladders, including step ladders must be checked regularly, be free from defects, and selected, by a competent person, to be suitable for the task." />
                    <ListItem text="The ladder must be of sufficient length to allow the operative to have three points of contact during their activity. Do not use the top three rungs to stand on." />
                    <ListItem text="The ladder must have secure footing and be tied off. The correct angle is 1 (out) in 4 (height)." />
                    <ListItem text="Be aware of, and avoid, electric lines overhead when positioning your ladder. Also avoid loose/ fragile material (such as window panes) at the top contact point" />
                    <ListItem text="Maintain three points of contact, your core should remain inside the stiles, and both feet should be on the same rung" />
                    <ListItem text="Do NOT overreach, and avoid sideways loading." />
                    <ListItem text="Ensure you do not overload the ladder as per the manufacturer’s requirements." />
                </ul>
            )
        },
        fal_fal_saf_lad: {
            name: "Safe Ladder",
            icon: fal_fal_saf_lad,
            text: (
                <ul>
                    <ListItem text="Ladders should NOT be used to carry out works that will be in one position for > 30 minutes. Other methods should be selected." />
                    <ListItem text="All ladders, including step ladders must be checked regularly, be free from defects, and selected, by a competent person, to be suitable for the task." />
                    <ListItem text="The ladder must be of sufficient length to allow the operative to have three points of contact during their activity. Do not use the top three rungs to stand on." />
                    <ListItem text="The ladder must have secure footing and be tied off. The correct angle is 1 (out) in 4 (height)." />
                    <ListItem text="Be aware of, and avoid, electric lines overhead when positioning your ladder. Also avoid loose/ fragile material (such as window panes) at the top contact point" />
                    <ListItem text="Maintain three points of contact, your core should remain inside the stiles, and both feet should be on the same rung" />
                    <ListItem text="Do NOT overreach, and avoid sideways loading." />
                    <ListItem text="Ensure you do not overload the ladder as per the manufacturer’s requirements." />
                </ul>
            )
        },
        fal_fal_a_lad: {
            name: "A Ladder",
            icon: fal_fal_a_lad,
            text: (
                <ul>
                    <ListItem text="Check all four step ladder feet are in contact with firm, level ground. Ensure locking devices are engaged. Ladders should not be placed near openings" />
                    <ListItem text="Only one person should use at a time and only carry light materials and tools. Maintain three points of contact " />
                    <ListItem text="Don’t overreach. Don’t work on the top three steps unless there is a suitable handhold. Avoid work that will impose a side load (if this is a risk, the ladder should be tied off)." />
                    <ListItem text="They are not to be used as supports for platforms" />
                </ul>
            )
        },
        fal_fal_roo_lad: {
            name: "Roof Ladder",
            icon: fal_fal_roo_lad,
            text: (
                <ul>
                    <ListItem text="Roof ladders should be used for accessing up and down slope roofs and in conjunction with a properly constructed scaffold platform." />
                    <ListItem text="They must be CE marked and be free from defects." />
                    <ListItem text="They should be long enough to reach and be securely anchored around the roof ridge. They must be strong enough for the span. The anchoring should not depend on the ridge capping which is liable to breakage, but should bear on the opposite slope." />
                    <ListItem text="They should be secured to prevent accidental movement" />
                    <ListItem text="You should not use eaves gutters as footing or to support a roof ladder." />
                </ul>
            )
        },
        fal_fal_tie_lad: {
            name: "Tie Ladder",
            icon: fal_fal_tie_lad,
            text: (
                <ul>
                    <ListItem text="All ladders must be tied or footed to prevent slipping or sliding" />
                    <ListItem text="The tie point must be capable of restraining the ladder." />
                    <ListItem text="Securing at the top is preferred, where it is possible." />
                    <ListItem text="Alternatively, an appropriate ladder stabilizing device, used in accordance with the manufacturer’s instructions, may be used." />
                </ul>
            )
        },
        fal_fal_tre_pla: {
            name: "Trestle Platform",
            icon: fal_fal_tre_pla,
            text: (
                <ul>
                    <ListItem text="Should only be used for light duty work (painting, rendering etc)" />
                    <ListItem text="Trestles must not span open holes or be used close to leading edges." />
                    <ListItem text="They must be erected by competent persons, and be checked for suitability before use. There should be a system of regular inspections during use, taking account of how it is being used and likelihood of deterioration." />
                    <ListItem text="The platform must be of sufficient size for the work (min 450mm wide), be level and fully boarded. Boards must be a minimum of 225mm wide and be non-slip. Each board must be fully supported, including both ends, with no overhangs." />
                    <ListItem text="Safe access (via a tied ladder) should be used." />
                    <ListItem text="Fall prevention needs to be used when the scope or duration of the task presents a risk of a fall occurring. Fall prevention includes toe boards and handrails. This will always be the case above 2m, but this does not mean lower height fall prevention measures are excluded." />
                    <ListItem text="They must be free from defects and suitable for their purpose." />
                    <ol>
                        <ListItem text="Wear and damage to hinges, pins, holes and feet" />
                        <ListItem text="Welds and crimps for cracks, distortion, separation or loose components" />
                        <ListItem text="Twisting of the frame (all feet firmly on level ground)" />
                        <ListItem text="Boards for wear, cracks or damage" />
                    </ol>
                    <ListItem text="Store trestles in an upright position and secure against falling. Store boards supported off the ground, away from risk of falling objects. Do not store other materials on top of the boards." />
                    <ListItem text=" Manufacturer approved locating pins must be used and inserted correctly." />
                    <ListItem text="The legs must be on firm foundations and not likely to slip or shift." />
                    <ListItem text="The platform must not be overloaded, kept free of trip hazards and kept tidy." />
                </ul>
            )
        },
        fal_fal_mob_sca: {
            name: "Mobile Scaffolding",
            icon: fal_fal_mob_sca,
            text: (
                <ul>
                    <ListItem text="These must be erected by CSCS Mobile Tower Scaffold Cardholders (or Basic/ Advanced scaffolding cardholders)" />
                    <ListItem text="Erectors must be provided with the manufacturer’s instructions. " />
                    <ListItem text="The scaffold must have the required safe working load for the task (including any equipment, material and the number of persons that must be carried)." />
                    <ListItem text="Ladders must be secured to the scaffold in accordance with the manufacturer’s instructions. Generally this EXCLUDES the use of external ladders. Generally ladders should be attached to the shorter side, with access “through the hatch”, capable of being closed and secured." />
                    <ListItem text="The workplace must be assessed, having regard to" />

                    <Li>
                        <Typography>
                            The workplace must be assessed, having regard to
                        </Typography>
                        <ol>
                            <ListItem text="Level ground with sufficient bearing capacity. They should not be used in close proximity to trenches, excavations or ground that has been filled." />
                            <ListItem text="The tower should be stabilised against overturning using a factor of safety of 1.5" />
                            <ListItem text="Sufficient space/manoeuvring area available to operate the scaffold free from obstructions." />
                            <ListItem text="The operating area for the scaffold must be kept free from any other site activities that may be ongoing." />
                            <ListItem text="Overhead electricity lines" />
                            <ListItem text="Heavy wind or rain will effect the risks associated with the scaffold and may effect the bearing capacity of the ground" />
                        </ol>
                    </Li>
                    <ListItem text="Keep the scaffold working platform free from obstacles (e.g. trailing leads or loose materials)" />
                    <ListItem text="Servicing or refuelling any tools should be done at ground level." />
                    <ListItem text="Generally safety harness lanyards should NOT be attached to Mobile scaffolding (due to risk of overturning)" />
                    <ListItem text="Operators can only access the scaffold after each wheel has been locked. The scaffold cannot be moved with operatives or materials on board. You should NOT use mechanical means to push the scaffold." />
                    <ListItem text="The platform must be fully boarded, have toe-boards, mid-rails and top guardrails." />
                </ul>
            )
        },
        fal_fal_sca: {
            name: "Scaffolding",
            icon: fal_fal_sca,
            text: (
                <ul>
                    <ListItem text="Where possible scaffolds should be used as working platforms when working at height." />
                    <ListItem text="These can only be erected, modified or dismantled by CSCS Basic/ Advanced scaffolding cardholders. " />
                    <ListItem text="You should have a formal handover procedure that both the erector and the user sign-off on suitability of the scaffold. The scaffold must be certified as safe to use." />
                    <ListItem text="Scaffolding must be adequately tied, braced and not overloaded." />
                    <ListItem text="Loading bays must be marked with the safe working load." />
                    <ListItem text="All platforms must be fully boarded, have toe-boards, mid-rails and top guardrails." />
                    <Li>
                        <Typography variant="title">
                            Where a scaffold exceeds 2m in height the scaffold
                            should be inspected weekly by a competent person and
                            should have a weekly GA3 report completed and
                            available on site. The scaffold will have to be
                            inspected by a competent person (who will produce a
                            written inspection report GA3 to be available on
                            site)
                        </Typography>
                        <ol>
                            <ListItem text="At least every 7 days (or after a period without use, before use re-commences)" />
                            <ListItem text="Exposure to bad weather, or" />
                            <ListItem text="Alteration, or" />
                            <ListItem text="Damage, including impact of traffic or site equipment with the scaffold." />
                        </ol>
                    </Li>
                    <ListItem text="If you discover a serious defect you should stop using the scaffold and report it to site management." />
                    <Li>
                        <Typography variant="title">should</Typography>
                        <ol>
                            <ListItem text="know and understand the conditions of use of the scaffold, including the loading capacity" />
                            <ListItem text="NOT overload the scaffold either locally or generally" />
                            <ListItem text="NOT interfere with or misuse the scaffold" />
                            <ListItem text="Promptly report defects in the scaffold to site management" />
                            <ListItem text="NOT leave the scaffold in a hazardous condition for current or subsequent users" />
                        </ol>
                    </Li>
                    <ListItem text="Any modifications (adding to or removing scaffold parts) must be undertaken by CSCS Basic/ Advanced scaffolding cardholders. Guard-rails and toe boards in a single bay may be temporarily removed by persons who have been appropriately instructed. Those persons must remain in attendance at the location of the removed guard-rail or toe-board until it has been replaced." />
                    <ListItem text="The scaffold must have designated access points. Users are not permitted to climb the scaffold structure and must use ladders. Ladders must be secured to the scaffold." />
                    <ListItem text="Materials of equipment must never be thrown or dropped from scaffolding." />
                    <ListItem text="Scaffold platforms must be kept clean and clear of materials with a clear passageway of 430mm for employees to pass." />
                    <ListItem text="Keep the scaffold working platform free from obstacles (e.g. trailing leads or loose materials)" />
                    <ListItem text="Operators can only access the scaffold after each wheel has been locked. The scaffold cannot be moved with operatives or materials on board. You should NOT use mechanical means to push the scaffold." />
                </ul>
            )
        },
        fal_fal_wor_pla: {
            name: "Working Platform",
            icon: fal_fal_wor_pla,
            text: (
                <ul>
                    <ListItem text="This is a platform that prevents a worker from falling to a lower level, such as scaffolds, MEWPs etc." />
                    <ListItem text="It must be secure, stable and level" />
                    <ListItem text="The Safe Working Load must be displayed/known, and you are not permitted to overload the platform." />
                    <ListItem text="It must provide safe passage, be large enough to allow the safe use of equipment and materials" />
                    <ListItem text="It must be maintained free from trip hazards, or gaps through which persons or materials could fall, with toe boards and handrails." />
                    <ListItem text="You must maintain the platform in a tidy condition, free from debris." />
                </ul>
            )
        },
        fal_fal_she_fan: {
            name: "Sheeting Fans",
            icon: fal_fal_she_fan,
            text: (
                <ul>
                    <ListItem text=" Sheeting (netting/plastic sheeting/corrugated sheets/timber sheets) should be used to enclose scaffolding on it’s public side to prevent loose material from falling onto members of the public. It needs to be securely fixed and inspected regularly, particularly after strong winds." />
                    <ListItem text="Sheeting materials should be fire resistant. (Note some flame-retardant sheeting gives off toxic gas emissions when exposed to high temperatures and therefore are not suitable for indoor use)" />
                    <ListItem text="Fans should be erected to supplement the sheeting, and consist of an inclined support extending from the scaffold and covered in decking." />
                    <ListItem text="They are the most suitable means of protecting passing pedestrians, and access points to the scaffold." />
                    <ListItem text="Sheeting and Fans will significantly increase the wind loading on the scaffold which needs to be accounted for by the erector within the scaffold structure, ties and couplings." />
                </ul>
            )
        },
        fal_fal_cra_boa: {
            name: "Crawling Boards",
            icon: fal_fal_cra_boa,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">
                            {" "}
                            Crawling boards may be used on fragile roofs,
                            adjacent to roof lights, or slippery surfaces. They
                            operate by spreading the load, and must be{" "}
                        </Typography>
                        <ol>
                            <ListItem text="strong enough to support the operative weight + any equipment" />
                            <ListItem text="Long enough to span the supports" />
                            <ListItem text="Secured to prevent accidental movement." />
                        </ol>
                    </Li>
                    <ListItem text="Guardrails are required around the area to prevent falls." />
                </ul>
            )
        },
        fal_fal_chu: {
            name: "Chutes",
            icon: fal_fal_chu,
            text: (
                <ul>
                    <ListItem text="Chutes should be used for discarding materials from upper floors, rather than throwing items from floors or scaffolding." />
                    <ListItem text="The Chute should terminate in a skip, with a suitable exclusion zone." />
                </ul>
            )
        },
        fal_fal_edg_pro: {
            name: "Edge Protection",
            icon: fal_fal_edg_pro,
            text: (
                <ul>
                    <ListItem text="All edges, where there is a risk of operatives falling off must be protected by barriers, handrails, mid-rails, toe-boards etc." />
                    <ListItem text="All edges where there is a risk of materials falling, must be protected using scaffolding/ platforms." />
                </ul>
            )
        },

        fal_fal_bar_fen_hoa: {
            name: "Barriers/ Fencing/ Hoarding",
            icon: fal_fal_bar,
            text: (
                <ul>
                    <ListItem text="Barriers must be used around any unattended openings or excavations." />
                    <ListItem text="Barriers should be used to exclude pedestrians from the works site." />
                    <ListItem text="Barriers should be at least 1.0m high and have a high visibility (red/white bar) rail. The bottom rail should be a maximum of 200mm from ground level. Be careful of hazard created by feet." />
                </ul>
            )
        },
        fal_fal_ope_hol: {
            name: "Open Holes/ Openings",
            icon: fal_fal_ope_hol,
            text: (
                <ul>
                    <ListItem
                        text="All openings (open manholes etc) must be guarded to prevent falls. This should be done using barriers.
"
                    />
                    <ListItem text="The opening should be closed or backfilled as soon as practicable." />
                    <ListItem text="When using covers, these must be set flush too, and fixed to the surrounding surface. They should have a textured surface to EN 124 (minimum 2mm) or high friction surface to USRV 35, and be strong enough for the potential loading." />
                </ul>
            )
        },
        fal_fal_sta_pro: {
            name: "Stair Protection",
            icon: fal_fal_sta_pro,
            text: (
                <ul>
                    <ListItem text="Suitable handrails and barriers must be erected on stair edges and around stair wells. Handrails should be at the appropriate height, have a visual contrast and permit a “power grip”." />
                    <ListItem text=" Stairs and stair wells should be adequately lit. Posters, signs and notice boards should NOT be positioned around stairs, as they may cause distraction" />
                    <ListItem text="It is good practice to apply contrasting/high visibility material on step edges." />
                    <ListItem text="Steps should have sufficient grip, and have consistent “going” and “risers”. The “going” should be large enough to place the ball of the foot on the step while descending. If this cannot be achieved, then controls to ensure that workers face the stairs while descending need to be introduced." />

                    <Li>
                        <Typography variant="title">
                            While using stairs you should NOT{" "}
                        </Typography>
                        <ol>
                            <ListItem text="Run" />
                            <ListItem text="Have your hands in your pockets" />
                            <ListItem text="Use hand-held devices or phones, or read" />
                            <ListItem text="Use stairs while they are being cleaned" />
                            <ListItem text="Carry open liquids" />
                            <ListItem text="Store items on steps" />
                        </ol>
                    </Li>
                    <ListItem text="You should use the handrails provided" />
                </ul>
            )
        },
        fal_fal_oh_wor: {
            name: "Overhead Work",
            icon: fal_fal_oh_wor,
            text: (
                <ul>
                    <ListItem text="Ensure that no work is taking place directly above you" />
                </ul>
            )
        },
        fal_fal_exc_zon: {
            name: "Exclusion Zone",
            icon: fal_fal_exc_zon,
            text: (
                <ul>
                    <ListItem text="Operatives should not work under an area where loads are being lifted or within the working radii of a job." />
                    <ListItem text=" Operatives should keep a safe distance from working plant (at least 2 machine lengths at any time)." />
                    <Li>
                        <Typography variant="title">
                            Operatives on foot must clearly know where such
                            zones are and how they are demarked{" "}
                        </Typography>
                        <ol>
                            <ListItem text="Barriers" />
                            <ListItem text="Markings/ Signage" />
                            <ListItem text="Method of Work" />
                        </ol>
                    </Li>
                </ul>
            )
        },
        fal_fal_sec_sto: {
            name: "Safe Storage",
            icon: fal_fal_sec_sto,
            text: (
                <ul>
                    <ListItem text=" Materials should be stored where they cannot fall on workers below." />
                    <ListItem text="Materials should be safely stacked" />
                    <ListItem text="Access routes for operatives and plant should be kept clear. Working areas must be kept clear. Ensure adequate space for access and loading activities" />
                    <ListItem text=" Debris or excavated/extracted material should be regularly removed from the area." />
                </ul>
            )
        },
        fal_fal_loa_bay: {
            name: "Loading Bay",
            icon: fal_fal_loa_bay,
            text: (
                <ul>
                    <ListItem text="Bay must have necessary load bearing capacity, and be sized to accommodate the required size of loads with sufficient room for safe access and working space. The maximum load bearing capacity should be clearly marked on each loading bay." />
                    <ListItem text="Vehicles should not be required to reverse in areas where workers are on foot, without full segregation (barriers) being in place. Where possible, one-way systems should be used." />
                    <ListItem text="Crossing of the loading bay by workers on foot should be strictly controlled, a safe distance from the loading point, and be directly lit." />
                    <ListItem text="Operatives on foot must wear high visibility PPE, and maintain awareness of their surroundings (not permitted to use mobile devices while in the area)" />
                    <ListItem text=" Working platforms must have adequate control measures in place to prevent falls. These areas must be kept clear, and must not be used to store materials." />
                </ul>
            )
        },
        fal_fal_mewp: {
            name: "MEWP",
            icon: fal_fal_mew,
            text: (
                <ul>
                    <ListItem text="Operators need appropriate training for the particular MEWP they are using, including assessment of suitability and risks in accordance with the manufacturer’s instructions. The manufacturer’s instructions will include a pre-operational checklist that must be completed before the MEWP is used." />
                    <ListItem text="A familiarisation induction should be given upon delivery to any operative using the MEWP. A ground person should also be briefed on how to use the ground controls, or any emergency decent controls." />
                    <ListItem text="The MEWP must have the required safe working load for the task (including any equipment, material and the number of persons that must be carried). Material loading should be limited to small, securable amounts for handwork.  In general, materials should be lifted by a separate telescopic handler, and loose materials should not be carried on the MEWP." />
                    <ListItem text="The MEWP should be CE marked. The MEWP must have a certificate of thorough examination valid within the last 6 months." />
                    <Li>
                        <Typography variant="title">
                            The workplace must be assessed, having regard to
                        </Typography>
                        <ol>
                            <ListItem text="Level ground with sufficient bearing capacity. They should not be used in close proximity to trenches, excavations or ground that has been filled." />
                            <ListItem text="Sufficient space/manoeuvring area available to operate the MEWP free from obstructions." />
                            <ListItem text="The operating area for the MEWP must be kept free from any other site activities that may be ongoing." />
                            <ListItem text="Overhead electricity lines" />
                            <ListItem text="Overhead obstacles that could lead to trapping or crushing injuries" />
                            <ListItem text="Heavy wind or rain will effect the operation of the MEWP and may effect the bearing capacity of the ground" />
                        </ol>
                    </Li>
                    <ListItem text="Keep the MEWP working platform free from obstacles (e.g. trailing leads or loose materials)" />
                    <ListItem text="Servicing or refuelling any tools should be done at ground level." />
                    <ListItem text="Any fault must be reported, and the MEWP clearly tagged as “out of service” with the keys removed." />
                    <ListItem text="Generally boom type MEWPs require a full body harness with a short restraint type lanyard (due to risk of boom swing, jolt or tilt)" />
                    <ListItem text="When working near water, risks associated with drowning (wearing a life jacket) are assessed compared to risks associated with falling (wearing a harness). The appropriate control should be selected." />
                    <ListItem text="Consider Hard Hats that have chin straps where appropriate when selecting PPE." />
                </ul>
            )
        },
        fal_fal_goo_per_hoi: {
            name: "Goods/ Person Hoist",
            icon: fal_fal_goo_per_hoi,
            text: (
                <ul>
                    <ListItem text="A hoist can only be used after it has been certified by the installer. Any modification will require re-certification." />
                    <ListItem text="The landing areas for the hoist must NOT have risk of falls (use barriers, fencing, toe boards as appropriate)" />
                    <ListItem text="The landing areas for the hoist must be kept clear and ensure a high level of housekeeping." />
                    <ListItem text="You must adhere to the maximum loadings (displayed on the hoist)." />
                </ul>
            )
        },
        fal_fal_pal_bal_sec: {
            name: "Ballets/ Bales/ Secure Loads",
            icon: fal_fal_pal_bal_sec,
            text: (
                <ListItem text="Keep materials on pallets (or in bales) with adequate strapping to prevent them from falling when being lifted." />
            )
        },
        fal_fal_har: {
            name: "Harness",
            icon: fal_fal_har,
            text: (
                <ul>
                    <ListItem text="Cannot be used to replace safe working platforms or safety nets. (Fall restraint)." />
                    <ListItem text="Fall Arrest and Rescue equipment needs to be inspected regularly and visually before each use." />
                    <ListItem text="Operatives must be trained" />
                    <Li>
                        <Typography variant="title">
                            Should be used in connection with a rescue plan.
                            This plan must ensure the operative can be retrieved
                            as soon as possible after the fall and NOT wait on
                            emergency services response. There are 4 classes of
                            rescue, risk assessed for most suitable
                        </Typography>
                        <ol>
                            <ListItem text="Lowering a remote casualty" />
                            <ListItem text="Raising a remote casualty" />
                            <ListItem text="Self evacuation by descent" />
                            <ListItem text="Rescue another in descent (preferably avoided so that other complications are not introduced)" />
                        </ol>
                        <Typography variant="title">
                            The rescuer should not endanger themselves when
                            carrying out a rescue procedure
                        </Typography>
                    </Li>
                    <ListItem text="Will consist of a full-body harness (with webbing and padding), lanyard, shock absorber (if fall arrest rather than fall restraint) and suitable anchor/ tie off point." />
                    <ListItem text="The anchor must be capable of supporting the load in the required direction." />
                    <ListItem text="Ensure proper tie off to anchor points, and re-check before commencing, irrespective of how short the task is going to be." />
                    <ListItem text="The harness must be worn fully secured, comfortable but snug and positioned correctly." />
                    <ListItem text="All connection systems must have double action, self closing, self locking snap hooks to reduce the possibility of roll out" />
                    <ListItem text="Use safety helmets (With chin straps) instead of hard hats." />
                </ul>
            )
        },
        fal_fal_veh_pla_con: {
            name: "Vehicle Plant Controller",
            icon: fal_fal_veh_pla_con,
            text: (
                <ul>
                    <ListItem text="Also known as a Vehicle Banksman." />
                    <ListItem text="Reversing vehicles are a significant risk on construction sites. (about 25% of all deaths are caused by this)" />
                    <ListItem text="Vehicle controllers should only be used if it is not reasonably practicable to physically segregate workers on foot/public from vehicle maneouvres, or use one way/drive through systems that avoid the need for reversing." />
                    <ListItem text="Work must be organised and planned to minimize the need for reversing. The reversing areas should be planned out, clearly marked, and known to all workers/drivers. For fixed sites, the use of vehicle stop-blocks should be considered." />
                    <ListItem text="Workers not directly involved in the reversing operation must be kept out of the area, while reversing is taking place." />
                    <ListItem text="The driver cannot begin reversing until the Vehicle Controller gives positive confirmation that it is safe to do so. Before giving such a signal, the Vehicle Controller must check that it is safe, and all unnecessary workers are clear of the area." />
                    <ListItem text="Vehicle Controllers should be trained and use standard signals. Drivers of vehicles must also know the signals that are used, this may require induction before arriving/beginning duties on site. The driver may also be required to leave their cab, check the area to confirm space and control requirements with the Vehicle Controller prior to beginning reversing. This will depend on site arrangements." />
                    <ListItem text="The Vehicle Controller must be positioned in a safe location, outside of vehicle reversing paths, and be clearly visible to drivers at all times during signaling." />
                    <ListItem text="In high risk scenarios, OR if practicable in all other scenarios, the Vehicle Controller should be in 2-way radio communication with drivers. This may include having a “floating” handset, that is given to drivers during the reversing operation." />
                    <ListItem text="The Vehicle Controller should wear distinctive high visibility PPE to make them easily identifiable to drivers." />{" "}
                    <ListItem text="Any reversing vehicle MUST STOP IMMEDIATELY if the vehicle controller is not in view/radio contact lost." />
                </ul>
            )
        },
        fal_fal_blo_cor: {
            name: "Blockwork Courses",
            icon: fal_fal_blo_cor,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">
                            Consider the effect of weather (wind and rain) when
                            building courses
                        </Typography>
                        <ol>
                            <ListItem text="Can blow tools off" />
                            <ListItem text="Wind and rain can effect drying time of mortar creating risk of wall collapse if ignored" />
                        </ol>
                    </Li>
                </ul>
            )
        },
        fal_fal_lif_poi_eye: {
            name: "Lifting Points/ Eyes",
            icon: fal_fal_lif_poi_eye,
            text: (
                <ul>
                    <ListItem text=" These may be used for lift or for aiding fall arrest system (along with safety lines, lanyards etc)" />
                    <ListItem text=" Once the slab is installed, these should be removed by cutting to prevent a trip hazard." />
                </ul>
            )
        },
        fal_fal_net_bea_bag: {
            name: "Nets/ Bean Bags",
            icon: fal_fal_net_bea_bag,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">
                            Nets should only be erected by competent and trained
                            operatives. They must be installed in accordance
                            with the manufacturer’s instructions, including
                            within the specified range of fixing points. The
                            fall height and catching width is given as
                        </Typography>
                        <StyledTable>
                            <tbody>
                                <tr>
                                    <td>Fall Height</td>
                                    <td>{"< 1m"}</td>
                                    <td>{"< 3m"}</td>
                                    <td>{"< 6m"}</td>
                                </tr>
                                <tr>
                                    <td>Catching width</td>
                                    <td>> 2m</td>
                                    <td>> 2.5m</td>
                                    <td>> 3</td>
                                </tr>
                            </tbody>
                        </StyledTable>
                    </Li>
                    <ListItem text="Nets should be fitted to be less than 2m from fall area (at maximum point of sag)." />
                    <ListItem text="Adequate clearance (from staff, plant or stored materials) must be maintained underneath the net." />
                    <ListItem text="Material or rubbish should not be allowed to fall into nets." />
                    <ListItem text="Bean Bags (Air bags) should only be used where it is not possible to use safety nets. They must be of sufficient strength and have enough air pressure to ensure the falling person does not make contact with the ground. They must be installed in accordance with the manufacturer’s instructions. The guidance above for catching width should be followed over the entire length of the hazard. Bean-bags may be interconnected to achieve this using the manufacturer approved secure couplings." />
                </ul>
            )
        },
        fal_fal_blo_gra: {
            name: "Block Grabs & Nets",
            icon: fal_fal_blo_gra,
            text: (
                <ul>
                    <ListItem text="Block grabs come under the definition of lifting gear" />
                    <ListItem text=" The ground must be stable and level enough to lift the load" />
                    <ListItem text="There must be a certificate of thorough inspection and daily condition inspection" />
                    <ListItem text="You must have a slinger signaller present" />
                    <ListItem text="A net should be used around the blocks being lifted to catch any loose blocks." />
                </ul>
            )
        },
        fal_fal_cab_gua: {
            name: "Cab Guards/ FOPs",
            icon: fal_fal_cab_guar,
            text: (
                <ul>
                    <ListItem text="Cab must be sufficiently protected to prevent debris crushing or penetrating the operator area." />
                    <ListItem text="Perform a visual check at the beginning of each shift" />
                    <ListItem text="Thorough checks should be routinely performed" />
                </ul>
            )
        },
        fal_fal_mas_cli: {
            name: "Mast Climber",
            icon: fal_fal_mas_cli,
            text: (
                <ul>
                    <ListItem text=" Mast climbers can only be used on firm and level surfaces as specified by the manufacturer." />
                    <ListItem text="They must be installed, modified and repaired by a competent person" />
                    <ListItem text=" There must be a barriered exclusion zone around the base of the mast climber to prevent unauthorised access." />
                </ul>
            )
        },
        fal_fal_sti: {
            name: "Stilts",
            icon: fal_fal_sti,
            text: (
                <ul>
                    <ListItem text="Stilts should not be used where the ceiling height is > 3m, for walking backwards or on stairs." />
                    <ListItem text="Stilts can only be used on surfaces that are solid, level and can support stilt work activity. Floor surfaces must be cleared, swept and dry." />
                    <ListItem text="Stilts can only be used for light duty activities. Avoid handling long, heavy or cumbersome items." />
                    <ListItem text="The area to be plastered must be plaster ready with preparation and roughening work completed. Other workers should be kept away from the immediate area." />
                    <ListItem text="Stilts should not be used near internal openings or leading edges, where the ground is uneven/different levels, or where there is material, tools or equipment lying around. Sufficient fall controls are required in areas where stilts are to be used." />
                    <ListItem text="You should have a rigid platform for mounting/dismounting at a height equal to or greater than the height of the stilt. Stepladders should not be used. You must not balance on one stilt while attaching the other." />
                    <ListItem text="You should have a platform at the required height to access your tools/materials to avoid bending down below knee level." />
                    <ListItem text="You should work such that your Torso is vertical whenever possible." />
                    <ListItem text="Stilts must be kept clean and inspected before each use. Ensure that soles and ties are in good condition." />
                    <ListItem text="You should not continually use stilts for > 2 hours without at least a 30 minute break. You should not use stilts > 6 hours per day." />
                    <ListItem text="You should have a helper to assist you to keep the area clean and prepared, prevent bending, frequent decents or overstretching." />
                </ul>
            )
        },
        fal_fal_sit_spe_met: {
            name: "Site Specific Method Statement",
            icon: fal_fal_sit_spe_met_sta,
            text: (
                <ul>
                    <ListItem text="A Site Specific Method Statement/ Design will require the engineer/designer to visit the site to carry out the risk assessment. They will then decide on the appropriate controls. This will generally be the case for High Risk works or sites." />
                    <Li>
                        <Typography variant="title">
                            Generally, the engineer/designer will prepare the
                            following documents for you which you must be
                            familiar with and follow
                        </Typography>
                        <ol>
                            <ListItem text="Risk Assessment and Control Selection." />
                            <ListItem text="Contact details for information or site issues" />
                            <ListItem text="Details on design information, such as equipment lists, spacings, visibility, and scope of application of the design" />
                            <ListItem text="Location map" />
                            <ListItem text="Site specific layouts" />
                            <ListItem text="Method statements, these may be standard type operation procedures, or step by step instructions for each phase of the works." />
                            <ListItem text="Details of inspections to be undertaken, and records to be completed." />
                            <ListItem text="Site induction procedures/ Safe Systems of Works Plans" />
                        </ol>
                    </Li>
                </ul>
            )
        }
    }
};

export default json;
